<template>
  <div
    class="relative flex flex-col h-screen"
  >
    <TheAppBar
      class="w-full sticky"
      :use-updated="true"
      @on-logout="authStore.logoutAndRedirect()"
    />
    <Suspense>
      <router-view />
    </Suspense>
  </div>
</template>

<script lang="ts" setup async>
import { defineAsyncComponent } from 'vue'

// stores
import { useAuthStore } from 'SkynamoApp/AuthStore'

// components
const TheAppBar = defineAsyncComponent(() => import('SkynamoApp/TheAppBar'))

const authStore = useAuthStore()

</script>
